import c0 from './address_geocode_prefill_controller';
import c1 from './ai_chat_controller';
import c2 from './ama_publish_controller';
import c3 from './amount_toggle_controller';
import c4 from './auto_save_controller';
import c5 from './autolink_controller';
import c6 from './beacon_link_controller';
import c7 from './bridge/beacon_link_controller';
import c8 from './bridge/intercom_controller';
import c9 from './bridge/menu_controller';
import c10 from './bridge/navigation_controller';
import c11 from './character_count_controller';
import c12 from './click_tracker_controller';
import c13 from './confirm_submit_controller';
import c14 from './confirmation_controller';
import c15 from './copy_to_clipboard_controller';
import c16 from './custom_domain_validation_controller';
import c17 from './elapsed_controller';
import c18 from './email_validation_controller';
import c19 from './expandable_content_controller';
import c20 from './extra_support_controller';
import c21 from './feed_item_switcher_controller';
import c22 from './form_controller';
import c23 from './frame_poll_controller';
import c24 from './highcharts_controller';
import c25 from './image_preview_controller';
import c26 from './inline_edit_controller';
import c27 from './live_activity_feed_controller';
import c28 from './live_console_controller';
import c29 from './live_poll_dashboard_controller';
import c30 from './live_poll_options_controller';
import c31 from './local_time_controller';
import c32 from './login_code_controller';
import c33 from './login_controller';
import c34 from './new_tab_link_controller';
import c35 from './notification_preferences_controller';
import c36 from './password_validator_controller';
import c37 from './plan_toggle_controller';
import c38 from './plan_unwrap_controller';
import c39 from './playlist_sort_confirm_controller';
import c40 from './podcast_picker_controller';
import c41 from './podcast_rows_controller';
import c42 from './post_episode_picker_controller';
import c43 from './preview_controller';
import c44 from './preview_target_controller';
import c45 from './promotion_order_controller';
import c46 from './purchase_checkout_controller';
import c47 from './range_selector_controller';
import c48 from './require_choice_controller';
import c49 from './search_filter_controller';
import c50 from './search_toggle_controller';
import c51 from './season_confirm_controller';
import c52 from './season_number_controller';
import c53 from './settings_search_controller';
import c54 from './share_link_controller';
import c55 from './shopify_buy_button_controller';
import c56 from './sortable_list_controller';
import c57 from './status_page_controller';
import c58 from './stripe_confirm_controller';
import c59 from './stripe_payment_controller';
import c60 from './switch_subdomain_controller';
import c61 from './tabs_controller';
import c62 from './tiptap_controller';
import c63 from './tom_select_controller';
import c64 from './trix_default_message_controller';
import c65 from './trix_no_attachments_controller';
import c66 from './trix_restricted_toolbar_controller';
import c67 from './trix_upload_controller';
import c68 from './typed_confirmation_controller';
import c69 from './unsaved_changes_controller';
import c70 from './visibility_toggle_controller';
import c71 from './welcome_message_controller';
import c72 from './welcome_upload_controller';
export const definitions = [
	{identifier: 'address-geocode-prefill', controllerConstructor: c0},
	{identifier: 'ai-chat', controllerConstructor: c1},
	{identifier: 'ama-publish', controllerConstructor: c2},
	{identifier: 'amount-toggle', controllerConstructor: c3},
	{identifier: 'auto-save', controllerConstructor: c4},
	{identifier: 'autolink', controllerConstructor: c5},
	{identifier: 'beacon-link', controllerConstructor: c6},
	{identifier: 'bridge--beacon-link', controllerConstructor: c7},
	{identifier: 'bridge--intercom', controllerConstructor: c8},
	{identifier: 'bridge--menu', controllerConstructor: c9},
	{identifier: 'bridge--navigation', controllerConstructor: c10},
	{identifier: 'character-count', controllerConstructor: c11},
	{identifier: 'click-tracker', controllerConstructor: c12},
	{identifier: 'confirm-submit', controllerConstructor: c13},
	{identifier: 'confirmation', controllerConstructor: c14},
	{identifier: 'copy-to-clipboard', controllerConstructor: c15},
	{identifier: 'custom-domain-validation', controllerConstructor: c16},
	{identifier: 'elapsed', controllerConstructor: c17},
	{identifier: 'email-validation', controllerConstructor: c18},
	{identifier: 'expandable-content', controllerConstructor: c19},
	{identifier: 'extra-support', controllerConstructor: c20},
	{identifier: 'feed-item-switcher', controllerConstructor: c21},
	{identifier: 'form', controllerConstructor: c22},
	{identifier: 'frame-poll', controllerConstructor: c23},
	{identifier: 'highcharts', controllerConstructor: c24},
	{identifier: 'image-preview', controllerConstructor: c25},
	{identifier: 'inline-edit', controllerConstructor: c26},
	{identifier: 'live-activity-feed', controllerConstructor: c27},
	{identifier: 'live-console', controllerConstructor: c28},
	{identifier: 'live-poll-dashboard', controllerConstructor: c29},
	{identifier: 'live-poll-options', controllerConstructor: c30},
	{identifier: 'local-time', controllerConstructor: c31},
	{identifier: 'login-code', controllerConstructor: c32},
	{identifier: 'login', controllerConstructor: c33},
	{identifier: 'new-tab-link', controllerConstructor: c34},
	{identifier: 'notification-preferences', controllerConstructor: c35},
	{identifier: 'password-validator', controllerConstructor: c36},
	{identifier: 'plan-toggle', controllerConstructor: c37},
	{identifier: 'plan-unwrap', controllerConstructor: c38},
	{identifier: 'playlist-sort-confirm', controllerConstructor: c39},
	{identifier: 'podcast-picker', controllerConstructor: c40},
	{identifier: 'podcast-rows', controllerConstructor: c41},
	{identifier: 'post-episode-picker', controllerConstructor: c42},
	{identifier: 'preview', controllerConstructor: c43},
	{identifier: 'preview-target', controllerConstructor: c44},
	{identifier: 'promotion-order', controllerConstructor: c45},
	{identifier: 'purchase-checkout', controllerConstructor: c46},
	{identifier: 'range-selector', controllerConstructor: c47},
	{identifier: 'require-choice', controllerConstructor: c48},
	{identifier: 'search-filter', controllerConstructor: c49},
	{identifier: 'search-toggle', controllerConstructor: c50},
	{identifier: 'season-confirm', controllerConstructor: c51},
	{identifier: 'season-number', controllerConstructor: c52},
	{identifier: 'settings-search', controllerConstructor: c53},
	{identifier: 'share-link', controllerConstructor: c54},
	{identifier: 'shopify-buy-button', controllerConstructor: c55},
	{identifier: 'sortable-list', controllerConstructor: c56},
	{identifier: 'status-page', controllerConstructor: c57},
	{identifier: 'stripe-confirm', controllerConstructor: c58},
	{identifier: 'stripe-payment', controllerConstructor: c59},
	{identifier: 'switch-subdomain', controllerConstructor: c60},
	{identifier: 'tabs', controllerConstructor: c61},
	{identifier: 'tiptap', controllerConstructor: c62},
	{identifier: 'tom-select', controllerConstructor: c63},
	{identifier: 'trix-default-message', controllerConstructor: c64},
	{identifier: 'trix-no-attachments', controllerConstructor: c65},
	{identifier: 'trix-restricted-toolbar', controllerConstructor: c66},
	{identifier: 'trix-upload', controllerConstructor: c67},
	{identifier: 'typed-confirmation', controllerConstructor: c68},
	{identifier: 'unsaved-changes', controllerConstructor: c69},
	{identifier: 'visibility-toggle', controllerConstructor: c70},
	{identifier: 'welcome-message', controllerConstructor: c71},
	{identifier: 'welcome-upload', controllerConstructor: c72},
];
